<template>
  <div class="px-4 mt-5 md:px-0" v-if="agent">
    <hr class="my-8" />
    <h1 class="pb-8 text-xl font-semibold">Personal Information</h1>
    <div class="flex justify-between">
      <div class="flex flex-col md:w-6/12">
        <table>
          <tbody>
            <tr>
              <td>Nationality:</td>
              <td v-if="agent.nationality">
                {{ agent.nationality.citizenship }}
              </td>
            </tr>
            <tr>
              <td>Languages:</td>
              <td v-if="agent.languages">{{ agent.languages }}</td>
            </tr>
            <tr>
              <td>Experience Since:</td>
              <td>{{ agent.experience_since }}</td>
            </tr>
            <!-- <tr>
              <td>LinkedIn:</td>
              <td class="text-primary">View Profile</td>
            </tr> -->
            <tr>
              <td>Area:</td>
              <td class="">{{ agent.address }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- <div class="flex justify-between w-5/12">
        <p>Area</p>
        <p>Dubai South (Dubai World Central)</p>
      </div> -->
    </div>
    <div
      class="flex flex-row mt-5 space-x-5 md:hidden"
      v-show="showContactInfoButtons"
    >
      <button
        @click="shareWhatsApp"
        class="flex items-center justify-center h-10 p-2 space-x-2 text-sm bg-white border rounded-md cursor-pointer md:text-base w-44 border-primary"
      >
        <WhatsAppSvg
          color="primary"
          class="fill-primary"
          height="4"
          width="4"
        />
        <p class="font-medium text-primary">WhatsApp</p>
      </button>
      <a
        :href="showPhoneDetails"
        @click="showPhoneNumber"
        class="flex items-center justify-center h-10 p-2 space-x-2 text-sm bg-white border rounded-md cursor-pointer md:text-base w-44 border-primary"
      >
        <CallSvg color="primary" class="fill-primary" height="4" width="4" />
        <p class="font-medium text-primary">Call</p>
      </a>
    </div>
    <div class="p-4 mt-3 rounded-md bg-stone-50" v-show="showContactDetails">
      <div class="flex justify-between">
        <div class="flex items-center w-7/12">
          <CallSvg color="secondary" height="4" width="4" />
          <span class="pl-2 text-secondary">{{ agent.whatsapp_number }}</span>
        </div>
        <div class="">
          <!-- <div class="w-6/12 p-2 bg-white rounded">
            <a
              :href="
                'mailto:' +
                agent.email +
                '?subject=Property Information  &body=Hi, I found your property with ref:' +
                agent.reference +
                ' on hutloop. Please contact me. Thank you.!'
              "
            >
              <EmailSvg color="secondary" height="5" width="5" />
            </a>
          </div> -->
          <div class="w-6/12 p-2 bg-white rounded">
            <button @click="shareWhatsApp">
              <WhatsAppSvg color="secondary" height="5" width="5" />
            </button>
          </div>
        </div>
      </div>

      <hr class="my-1" />
      <div>
        <p class="">
          <a href="" class="text-blue-400">{{ agent.name }}</a>
          <span class="pl-1" v-if="agent.languages">
            speaks {{ agent.languages.split(",")[0] }}</span
          >
        </p>
      </div>
    </div>
    <hr class="my-8" />
    <h1 class="pb-4 text-xl font-semibold">About Me</h1>
    <p class="leading-loose tracking-wide" v-html="agent.description"></p>
    <hr class="my-8" />
    <div class="mt-8" v-if="localProperties && localProperties.length > 0">
      <div class="flex flex-col">
        <div class="flex flex-row space-x-3">
          <div class="w-auto">
            <DropDown
              height="[48px]"
              buttonLabel="Buy"
              :menu-items="propertyTenureOptions || []"
              radius="lg"
              unique-identifier="buy"
              @menu-item-selected="handlePropertyTenureMenuItemSelected"
            />
          </div>
          <DropDown
            height="[48px]"
            buttonLabel="Featured"
            :menu-items="propertyFilters"
            radius="lg"
            unique-identifier="filters"
            @menu-item-selected="handleMenuItemSelected"
          />
        </div>
      </div>

      <div>
        <PropertyCard :properties="localProperties" />
      </div>
    </div>
    <SignInModal
      :showViewModal="showLoginModal"
      :modalType="modalType"
      @closeViewModal="closeModal"
      @switchModalType="handleSwitchModalType"
    />
  </div>
</template>
<script setup>
import { ref, reactive, watch, onMounted, defineProps, defineEmits } from "vue";
import axios from "axios";
import DropDown from "@/components/form-components/DropDown.vue";
import PropertyCard from "@/features/properties/PropertyCard.vue";
import WhatsAppSvg from "@/components/svg/WhatsAppSvg.vue";
import CallSvg from "@/components/svg/CallSvg.vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import useAuth from "@/composables/useAuth";
import SignInModal from "@/components/LoginModal.vue";
// Define props
const props = defineProps({
  agent: Object,
  properties: Array,
});
const { state: authState } = useAuth();
const isAuthenticated = ref(authState.isAuthenticated);

watch(
  () => authState.isAuthenticated,
  (newVal) => {
    isAuthenticated.value = newVal;
  }
);
const showPhoneDetails = ref(null);
const showEmailDetails = ref(null);
const showContactInfoButtons = ref(true);
const showLoginModal = ref(false);
const modalType = ref("");
const showContactDetails = ref(false);

// Define emits
defineEmits(["menu-item-selected"]);

// State
const localProperties = ref(props.properties);
// const isDropdownOpen = ref(false);
const propertyTenureOptions = ref(null);

// Vuex store and route
const store = useStore();
const route = useRoute();

const propertyFilters = reactive({ ...store.state.propertyFilters });
const baseUrl = store.state.baseUrl;

watch(
  () => props.properties,
  (newProperties) => {
    localProperties.value = newProperties;
  }
);

onMounted(() => {
  axios
    .get(`${baseUrl}property-tenure-options`)
    .then((response) => {
      propertyTenureOptions.value = response.data.data;
    })
    .catch((error) => console.log(error));
});

const handleMenuItemSelected = (payload) => {
  const sortedValue = payload.itemId;
  axios
    .get(`${baseUrl}property-filters`, {
      params: {
        sort_by: sortedValue,
        user_id: route.params.id,
      },
    })
    .then((response) => {
      localProperties.value = response.data.data;
    })
    .catch((error) => console.log(error));
};

const shareWhatsApp = () => {
  if (isAuthenticated.value == true) {
    const message = `Hi, I found your property with ref: ${props.agent.reference} on Hutloop. Please contact me. Thank you.!`;
    const showWhatsAppDetails = `https://api.whatsapp.com/send?phone=${
      props.agent.whatsapp_number
    }&text=${encodeURIComponent(message)}`;
    window.open(showWhatsAppDetails, "_blank");
  }
};

const showPhoneNumber = () => {
  showContactInfoButtons.value = false;
  if (isAuthenticated.value) {
    showContactDetails.value = true;
    showPhoneDetails.value = "tel:" + props.agent.phone;
    showEmailDetails.value = `mailto: 
          ${props.agent.email}
          ?subject=Hutloop Property  &body=Hi, I found your property with ref: ${props.agent.reference} on Hutloop. Please contact me. Thank you.!`;
  } else {
    showLoginModal.value = true;
    modalType.value = "login";
  }
};

const handlePropertyTenureMenuItemSelected = (payload) => {
  const tenureId = payload.itemId;
  axios
    .get(`${baseUrl}property-filters`, {
      params: {
        property_tenure_option_id: tenureId,
        user_id: route.params.id,
      },
    })
    .then((response) => {
      localProperties.value = response.data.data;
    })
    .catch((error) => console.log(error));
};

const handleSwitchModalType = (type) => {
  modalType.value = type;
};

const closeModal = () => {
  showLoginModal.value = false;
  modalType.value = "";
};

// const toggleDropdown = () => {
//   isDropdownOpen.value = !isDropdownOpen.value;
// };
</script>
